import React, { useEffect, useState } from "react";
import { Alert, Button, Spinner, Table } from "react-bootstrap";
import { AddressDisplay } from "../../../components/AddressForm";
import { useAuth } from "../../../providers/authprovider";
import RajcompanyDeleteModal from "./RajcompanyDeleteModal";
import RajcompanyEditModal from "./RajcompanyEditModal";
import RajcompanyLogo from "../../../components/RajcompanyLogo";

const displayValue = (value) => {
  const text = (value ?? "").toString().trim();

  return text === "" ? <span className="text-muted">-</span> : text;
};

export default function RajcompaniesSettingsTable() {
  const { rajcompanies } = useAuth();
  const [companies, setCompanies] = useState(undefined);
  const [error, setError] = useState("");
  const [editModal, setEditModal] = useState({ show: false, company: null });
  const [deleteModal, setDeleteModal] = useState({ show: false, company: null });
  // Podmiana loga/pieczatki nie zmienia `has_logo`/`has_stamp`, wiec podglad
  // trzeba przeladowac recznie.
  const [logoVersion, setLogoVersion] = useState(0);

  useEffect(() => {
    rajcompanies.get(null, ({ success, error, content }) => {
      if (success) {
        setCompanies(content);
        return;
      }

      setError(error);
      setCompanies([]);
    });
  }, [rajcompanies]);

  const handleSaved = (company) => {
    setLogoVersion((version) => version + 1);

    const index = companies.findIndex((item) => item.id === company.id);

    if (index > -1) {
      const nextCompanies = [...companies];
      nextCompanies.splice(index, 1, company);
      setCompanies(nextCompanies);
      return;
    }

    setCompanies([...companies, company]);
  };

  const handleDeleted = (companyId) => {
    setCompanies(companies.filter((company) => company.id !== companyId));
  };

  return (
    <div className="p-3 border rounded bg-light mb-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Edycja spółek</h5>
        <Button size="sm" onClick={() => setEditModal({ show: true, company: null })}>
          Dodaj spółkę
        </Button>
      </div>

      {companies === undefined && (
        <div className="text-muted">
          <Spinner size="sm" className="me-2" />
          Pobieranie spółek...
        </div>
      )}

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      {companies !== undefined && !error && (
        <Table size="sm" striped bordered hover responsive className="mb-0 align-middle">
          <thead>
            <tr>
              <th>#</th>
              <th>Logo</th>
              <th>Pieczątka</th>
              <th>Pełna nazwa</th>
              <th>NIP</th>
              <th>REGON</th>
              <th>KRS</th>
              <th>Telefon</th>
              <th>WWW</th>
              <th>Adres</th>
              <th>Domyślna</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {companies.length === 0 && (
              <tr>
                <td colSpan={12}className="text-muted text-center">
                  Brak spółek.
                </td>
              </tr>
            )}
            {companies.map((company, index) => (
              <tr key={company.id}>
                <td>{index + 1}</td>
                <td>
                  <RajcompanyLogo
                    key={`${company.id}-${logoVersion}`}
                    companyId={company.id}
                    hasLogo={company.has_logo}
                  />
                </td>
                <td>
                  <RajcompanyLogo
                    key={`${company.id}-stamp-${logoVersion}`}
                    companyId={company.id}
                    hasLogo={company.has_stamp}
                    type="stamp"
                  />
                </td>
                <td>{company.full_name}</td>
                <td>{displayValue(company.nip)}</td>
                <td>{displayValue(company.regon)}</td>
                <td style={{ maxWidth: 260, whiteSpace: "pre-wrap" }}>
                  {displayValue(company.krs)}
                </td>
                <td className="text-nowrap">{displayValue(company.phone)}</td>
                <td>{displayValue(company.www)}</td>
                <td>
                  <AddressDisplay address={company.address} />
                </td>
                <td className="text-center">
                  <input type="checkbox" checked={!!company.default} disabled readOnly />
                </td>
                <td className="text-nowrap">
                  <Button
                    size="sm"
                    variant="outline-primary"
                    className="me-2"
                    onClick={() => setEditModal({ show: true, company })}
                  >
                    Edytuj
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => setDeleteModal({ show: true, company })}
                  >
                    Usuń
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {editModal.show && (
        <RajcompanyEditModal
          show={editModal.show}
          company={editModal.company}
          onHide={() => setEditModal({ show: false, company: null })}
          onSaved={handleSaved}
        />
      )}

      {deleteModal.show && (
        <RajcompanyDeleteModal
          show={deleteModal.show}
          company={deleteModal.company}
          onHide={() => setDeleteModal({ show: false, company: null })}
          onDeleted={handleDeleted}
        />
      )}
    </div>
  );
}
